// Generated by Melange

import * as Fx from "../fx/fx.jsx";
import * as Store__Context from "../store/context.jsx";

function use(param) {
  const store = Store__Context.useStore(undefined);
  return function (fx) {
    return Fx.run(fx, {
      store: store
    });
  };
}

export {
  use,
}
/* Store__Context Not a pure module */
